import React, { Fragment, useMemo } from 'react';
import { DataGrid, esES } from '@material-ui/data-grid';
import { Visibility } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { formatDate } from 'hooks/Pipe';

const columns = [
  {
    field: 'document',
    headerName: 'Documento',
    width: 160,
    sortable: false,
    renderCell: (cellValues) => {
      return (
        <Fragment>
          {cellValues.row.document}
          <Link
            style={{
              marginLeft: '10px',
            }}
            to={`/admin/ventas/operaciones/pedidos/${cellValues.row.sale_order_id}`}
            target="_blank"
          >
            <Visibility style={{ fontSize: 18 }} />
          </Link>
        </Fragment>
      );
    },
    align: 'center',
  },
  { field: 'DocTotal', headerName: 'Total', width: 100, sortable: false, align: 'center' },
  { field: 'PaidToDate', headerName: 'Pagado', width: 100, sortable: false, align: 'center' },
  { field: 'SlpName', headerName: 'Vendedor', width: 300, sortable: false },
  { field: 'ImportEnt', headerName: 'Hoja reparto', width: 110, sortable: false, align: 'center' },
  { field: 'program_date', headerName: 'Fecha programada', width: 110, sortable: false, align: 'center' },
  { field: 'dispatch_date', headerName: 'Fecha despacho', width: 110, sortable: false, align: 'center' },
  { field: 'sheet_state', headerName: 'Estado hoja', width: 110, sortable: false, align: 'center' },
  { field: 'GroupNum', headerName: 'Crédito', width: 100, sortable: false, align: 'center' },
  { field: 'TaxDate', headerName: 'Fecha documento', width: 150, sortable: false, align: 'center' },
  {
    field: 'DocDueDate',
    headerName: 'Fecha vencimiento',
    width: 150,
    sortable: false,
    align: 'center',
  },
];

function ExpiredInvoicesGrid(props) {
  const documents = useMemo(() => {
    if(props.documents === null) return [];
    return props.documents.map((item, index) => {
      return {
        id: index,
        document: `${item.U_SYP_MDSD}-${item.U_SYP_MDCD}`,
        DocTotal: item.DocTotal,
        PaidToDate: item.PaidToDate,
        SlpName: item.SlpName,
        ImportEnt: item.ImportEnt,
        program_date: formatDate(item.program_date, 'F'),
        dispatch_date: formatDate(item.dispatch_date, 'F'),
        sheet_state: item.sheet_state === 'W'
          ? 'En reparto'
          : item.sheet_state === 'A'
          ? 'Anulado'
          : item.sheet_state === 'F'
          ? 'Facturado'
          : item.sheet_state === '4'
          ? 'Liq Doc +'
          : item.sheet_state === '5'
          ? 'Cerrado'
          : 'Estado desconocido',
        GroupNum: item.GroupNum == -1 ? 'No' : 'Si',
        TaxDate: formatDate(item.TaxDate, 'F'),
        DocDueDate: formatDate(item.DocDueDate, 'F'),
        sale_order_id: item.sale_order_id,
      };
    });
  }, [props.documents]);

  

  return (
    <div
      style={{ height: documents.length > 2 ? '200px' : undefined, display: 'flex', flexGrow: '1' }}
    >
      <DataGrid
        localeText={esES.props.MuiDataGrid.localeText}
        columns={columns}
        rows={documents || []}
        loading={props.documents === null}
        pagination={false}
        autoHeight={documents.length > 2 ? false : true}
        hideFooterPagination={true}
        hideFooter={true}
        disableSelectionOnClick={true}
        disableMultipleSelection={true}
        disableColumnFilter={true}
        disableColumnMenu={true}
        disableColumnReorder={true}
        disableColumnSelector={true}
        disableColumnResize={true}
        disableMultipleColumnsSorting={true}
      />
    </div>
  );
}

export default ExpiredInvoicesGrid;
